import { ALERT } from '../model/msg/equip';
import { getEquipPriceLayerTpl } from './../model/tpl/equip';
import { isDefined, not, truthy, anyOf, numberWithCommas, getDivideIntStrByThousandUnit } from '../../../utils/util';
import { API_DOMAIN_DEFAULT } from '../../../model/model';
import EquipModel from './EquipModel';

class EquipPriceLayer {
  constructor(options) {
    const _ = this;

    _.option = $.extend({
      global: window
    }, options);

    _.model = EquipModel.getInstance();

    _.contents = null;

    _.displayLowestPrice = null;

    _.displayAveragePrice = null;

    _.uniqueId = Date.now();

    _.proxy = {
      documentEventHandler: $.proxy(_.documentEventHandler, _)
    };

    _.global = _.option.global;
  }

  init() {
    const _ = this;

    _.contents = $(getEquipPriceLayerTpl());

    const priceNodes = $('dd', _.contents);

    _.displayLowestPrice = $(priceNodes.get(0));

    _.displayAveragePrice = $(priceNodes.get(1));

    _.setInstance();

    return _;
  }

  setInstance() {
    const _ = this;

    $('.layer-close', _.contents).on('click', function (evt) {
      evt.preventDefault();
      evt.stopPropagation();

      $(_).trigger({type: EquipPriceLayer.EVT_CLOSE});
    });
  }

  /*
  getPriceStr(str = '0') {
    const _ = this;

    let unitValues = getDivideIntStrByThousandUnit(str);
    unitValues.reverse();

    let priceStr = '';
    for (let i = 0, max = unitValues.length; i < max; i++) {
      priceStr = (numberWithCommas(unitValues[i]) + _.model.PRICE_UINTS[i]) + priceStr;

      if (i !== unitValues.length) priceStr = ' ' + priceStr;
    }

    return priceStr;
  }
  */

  setDocumentEventHandler(flag) {
    const _ = this;

    if (truthy(flag)) {
      $(document).on(`click.equippricelayer.${_.uniqueId}`, _.proxy.documentEventHandler);

    } else {
      $(document).off(`click.equippricelayer.${_.uniqueId}`, _.proxy.documentEventHandler);
    }

    return _;
  }

  documentEventHandler(evt) {
    const _ = this;

    switch (evt.type) {
      case 'click' :
        evt.preventDefault();

        if (anyOf(evt.target === _.contents.get(0), $.contains(_.contents.get(0), evt.target))) return;

        _.show(false);

        $(_).trigger({type: EquipPriceLayer.EVT_CLOSE});
        break;
    }

    return _;
  }

  /*
   * public methods
   */
  appendTo($node) {
    $node.append(this.contents);
  }

  show(flag) {
    const _ = this;

    _.setDocumentEventHandler(flag);

    (truthy(flag)) ? _.contents.show() : _.contents.hide();
  }

  setPrice(currentLowestPrice = '0', averagePrice = '0') {
    const _ = this;

    _.displayLowestPrice.text(currentLowestPrice);
    _.displayAveragePrice.text(averagePrice);
  }

  destroy() {
    const _ = this;

    _.setDocumentEventHandler(false);

    $('.layer-close', _.contents).off('click');
  }
}

EquipPriceLayer.EVT_CLOSE = 'EVT_CLOSE';

export default EquipPriceLayer;


// WEBPACK FOOTER //
// ./_src/js/world/characterSetting/equip/EquipPriceLayer.js